<template>
	<div class="setBusiness" v-loading.fullscreen.lock='loading'>
		<div class="setBusinessCon">
			<div class="fill">

				<el-button v-if='type==1&&status!=1' type="primary" style="margin-bottom: 20px;"
					@click="backGo()">上一步</el-button>

				<div v-if="status==1">
					<div class="title">
						<div class="sortCon" v-if="type==1">
							<div class="sort">1</div>
						</div>
						<div>
							{{type==2?'个人名片':'创建名片'}}
						</div>
					</div>

					<el-form :model="cardForm" ref="cardForm" :rules="cardRules" label-width="100px"
						label-position='top' class="demo-ruleForm">

						<el-form-item label="头像" prop="en_avatar">
							<el-upload class="avatars-uploader"
								action="https://zhunpin.work/api/admin/Qiniu/uploadImage" :show-file-list="false"
								:on-success="handleAvatar">
								<el-image v-if="cardForm.en_avatar" class="avatars" :src="cardForm.en_avatar" fit="cover"></el-image>
								<i v-else class="el-icon-plus avatars-uploader-icon"></i>
							</el-upload>
						</el-form-item>

						<el-form-item label="姓名" prop="en_user_name">
							<el-input v-model="cardForm.en_user_name" style="width: 300px;"></el-input>
						</el-form-item>

						<el-form-item label="我的职务" prop="en_job">
							<el-input v-model="cardForm.en_job" style="width: 300px;"></el-input>
						</el-form-item>

						<el-form-item v-if="type==1" label="企业名称" prop="company_name">
							<el-input v-model="cardForm.company_name" style="width: 300px;"></el-input>
						</el-form-item>

						<el-form-item label=" ">
							<el-button type="primary" class="save" @click="foundCard()">创建</el-button>
						</el-form-item>

					</el-form>
				</div>

				<div v-if="status==2">
					<div class="form">
						<el-form :model="ruleForm" ref="ruleForm" :rules="rules" :inline='true' label-width="100px"
							label-position='top' class="demo-ruleForm">

							<div class="title">
								<div class="sortCon">
									<div v-if="type==1" class="sort">2</div>
									<div v-else class="sort">1</div>
								</div>
								<div>
									 {{type==1?'填写基本信息':'修改资料'}}
								</div>
							</div>
							
							<el-form-item label="企业名称" prop="company_name">
								<el-input v-model="ruleForm.company_name" placeholder="企业名称" disabled style="width: 300px;"></el-input>
								<div style="color: #666;font-size: 13px;">如需修改企业名称，请联系平台客服</div>
							</el-form-item>

							<el-form-item label="企业简称" prop="simple_name">
								<el-input v-model="ruleForm.simple_name" placeholder="企业简称"
									style="width: 300px;"></el-input>
							</el-form-item>

							<el-form-item v-if='type==1' label="统一信用编码" prop="company_code">
								<el-input v-model="ruleForm.company_code" placeholder="信用编码"
									style="width: 300px;"></el-input>
							</el-form-item>

							<el-form-item label="公司规模" prop="person_count">
								<el-select v-model="ruleForm.person_count" placeholder="请选择" style="width: 300px;">
									<el-option v-for="(item,index) of scaleList" :key="index" :label="item"
										:value="item"></el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="地址" prop="company_address">
								<el-cascader :options="cityList" filterable :show-all-levels="true" :props="cityProps"
									style="width: 300px;" v-model="ruleForm.company_address"></el-cascader>
							</el-form-item>

							<el-form-item label="详细地址" prop="address_detail">
								<el-input v-model="ruleForm.address_detail" placeholder="详细地址"
									style="width: 300px;"></el-input>
							</el-form-item>

							<el-form-item v-if="type==2" label="公司介绍" prop="company_descrption">
								<el-input type="textarea" class="textarea" :autosize="{ minRows: 10, maxRows: 16}"
									placeholder="公司介绍" v-model="ruleForm.company_descrption" style="width: 740px;"></el-input>
							</el-form-item>

							<div class="title">
								<div class="sortCon">
									<div v-if="type==1" class="sort">3</div>
									<div v-else class="sort">2</div>
								</div>
								<div>
									上传公司信息
								</div>
							</div>

							<el-form-item label="Logo" prop="logo">
								<el-upload class="avatar-uploader comlogo"
									action="https://zhunpin.work/api/admin/Qiniu/uploadImage"
									:on-success="handleLogo" :show-file-list="false">
									<img v-if="ruleForm.logo" :src="ruleForm.logo" class="avatar comlogo">
									<i v-else class="el-icon-plus avatar-uploader-icon comlogo"></i>
								</el-upload>
							</el-form-item>

							<el-form-item v-if='type==1' label="营业执照" prop="business_license">
								<el-upload class="avatar-uploader"
									action="https://zhunpin.work/api/admin/Qiniu/uploadImage"
									:on-success="handleLicense" :show-file-list="false">
									<img v-if="ruleForm.business_license" :src="ruleForm.business_license"
										class="avatar ">
									<i v-else class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload>
							</el-form-item>
							
							<el-form-item v-if="type==2" label="公司相册" prop="name">
								<div class="album">
									<div  v-if="ruleForm.images.length>0" class="albums">
										<div v-for="(item,index) of ruleForm.images" :key="index" class="albumCon">
											<el-image :src="item" fit="cover" class="albumLi"></el-image>
											<i  class='el-icon-circle-close close'  @click="closeAlbum(index)"></i>
										</div>
									</div>
									<el-upload v-if="ruleForm.images.length<10" class="avatar-uploader photo"
									    action="https://zhunpin.work/api/admin/Qiniu/uploadImage"
										:on-success="handleAlbum" 
										:show-file-list="false">
										<!-- <el-image v-if="ruleForm.imageUrl" :src="ruleForm.imageUrl" fit="cover"
											class="avatar"></el-image> -->
										<i class="el-icon-plus avatar-uploader-icon photo"></i>
									</el-upload>
								</div>
							</el-form-item>

						</el-form>
					</div>

				</div>

				<div v-if="status==2" class="buttonG">
					<el-button v-if="type==2" type="primary" plain @click="backGo()">返回</el-button>
					<el-button type="primary" class="save" @click="submit()">提交</el-button>
				</div>

				<div v-if="status==3">
					<div class="form">
						<el-form :model="joinForm" ref="joinForm" :rules="joinRules" :inline='true' label-width="100px"
							label-position='top' class="demo-ruleForm">

							<div class="title">
								<div class="sortCon">
									<div class="sort">1</div>
								</div>
								<div>
									填写信息
								</div>
							</div>

							<el-form-item label="企业名称" prop="company_name">
								<el-input v-model="joinForm.company_name" placeholder="企业名称" disabled
									style="width: 300px;"></el-input>
							</el-form-item>

							<el-form-item label="申请加入说明" prop="name">
								<el-input type="textarea" class="textarea" :autosize="{ minRows: 10, maxRows: 16}"
									placeholder="请简略说明加入该公司的理由或证明身份,以便公司管理员审核" v-model="joinForm.remarks"
									style="width: 740px;"></el-input>
							</el-form-item>

							<el-form-item label=" ">
								<el-button type="primary" class="save" @click="joinCompany()">加入</el-button>
							</el-form-item>

						</el-form>
					</div>

				</div>


			</div>
		</div>
	</div>
</template>

<script>
	import {
		scaleList
	} from '@/unit/disposition.js';
	export default {
		name: 'setBusiness',
		data() {
			return {
				ruleForm: {
					company_name: '',
					simple_name: '',
					company_code: '',
					person_count: '',
					business_license: '',
					company_address: '',
					address_detail: '',
					logo: '',
					images:[]
				},
				rules: {
					company_name: [{
						required: true,
						message: '请输入',
						trigger: 'blur'
					}, ],
					simple_name: [{
						required: true,
						message: '请输入简称',
						trigger: 'blur'
					}, ],
					company_code: [{
						required: true,
						message: '请输入信用编码',
						trigger: 'blur'
					}, ],
					person_count: [{
						required: true,
						message: '请选择',
						trigger: 'blur'
					}, ],
					business_license: [{
						required: true,
						message: '请上传营业执照',
						trigger: 'blur'
					}, ],
					company_address: [{
						required: true,
						message: '请选择地址',
						trigger: 'blur'
					}, ],
					address_detail: [{
						required: true,
						message: '请输入地址',
						trigger: 'blur'
					}, ],
					logo: [{
						required: true,
						message: '请上传Logo',
						trigger: 'blur'
					}, ],
				},
				joinForm:{
					company_name: '',
					remarks: ''
				},
				joinRules: {
					company_name: [{
						required: true,
						message: '请输入',
						trigger: 'blur'
					}, ],
					remarks: [{
						required: true,
						message: '请输入申请加入说明',
						trigger: 'blur'
					}, ],
				},
				scaleList,
				type: 1, //1创建 2是修改
				status: 1, //1是创建名片 2.创建 3.加入
				cardForm: {
					en_job: '',
					en_avatar: '',
					en_user_name: '',
					company_name: ''
				},
				cardRules: {
					company_name:[{
						required: true,
						message: '请输入企业名称',
						trigger: 'blur'
					}],
					en_job: [{
						required: true,
						message: '请输入我的职务',
						trigger: 'blur'
					}, ],
					en_avatar: [{
						required: true,
						message: '请上传头像',
						trigger: 'blur'
					}, ],
					en_user_name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}, ],
					en_user_name: [{
						required: true,
						message: '请输入我的公司',
						trigger: 'blur'
					}, ],
				},
				loading: false,
				cityList: [],
				cityProps: {
					value: 'name',
					label: 'name',
					children: 'city',
					emitPath: true
				},
			}
		},
		created() {
			if(this.$route.query.type==2){
				this.type=this.$route.query.type
				this.status=this.$route.query.status
				if(this.status==1){
					this.getInfo()
				}
				if(this.status==2){
					this.getcomDe()
				}
			}
			
			this.getCity()
		},
		methods: {
			getInfo(){
				this.loading = true
				this.$axios.get('/api/client/User/resumeDetails').then(res => {
					this.loading = false
					if (res.code == 200) {
						if(this.status==1){
							this.cardForm={
								en_job: res.data.en_job,
								en_avatar: res.data.en_avatar,
								en_user_name: res.data.en_user_name,
							}
						}
						if(this.status==2){
							this.ruleForm={
								company_name: res.data.company_name,
								company_address:res.data.company_address,
								address_detail:res.data.address_detail,
								address_code:res.data.address_code,
								person_count:res.data.person_count,
								company_descrption:res.data.company_descrption,
								images:res.data.images==null?[]:res.data.images.split(','),
								simple_name:res.data.simple_name
							}
						}
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			getcomDe(){
				this.loading = true
				this.$axios.get('/api/client/ES/getCompanyData').then(res => {
					this.loading = false
					if (res.code == 200) {
						if(this.status==2){
							this.ruleForm={
								logo: res.data.logo,
								company_name: res.data.company_name,
								company_address:res.data.company_address.split('-'),
								address_detail:res.data.address_detail,
								address_code:res.data.address_code,
								person_count:res.data.person_count,
								company_descrption:res.data.company_descrption,
								images:res.data.images==null?[]:res.data.images.split(','),
								simple_name:res.data.simple_name
							}
						}
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			backGo() {
				if (this.type == 1) {
					this.status = 1
				} else {
					this.$router.go(-1)
				}
			},
			closeAlbum(index){
				this.ruleForm.images.splice(index,1)
			},
			// 相册
			handleAlbum(res, file){
				if (res.code == 200) {
					this.ruleForm.images.push(res.data)
				}
			},
			// 企业名片
			handleAvatar(res, file) {
				if (res.code == 200) {
					this.cardForm.en_avatar = res.data
				}
			},
			//营业执照
			handleLicense(res, file) {
				if (res.code == 200) {
					this.ruleForm.business_license = res.data
				}
			},
			//logo
			handleLogo(res, file) {
				if (res.code == 200) {
					this.ruleForm.logo = res.data
				}
			},
			// 获取省市区
			getCity() {
				this.$axios.get('/api/client/Common/getArea').then(res => {
					if (res.code == 200) {
						this.cityList = res.data
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			// 查找公司是否存在
			findCompany() {
				this.loading = true
				this.$axios.get('/api/client/Common/getCompany', {
					params: {
						company_name: this.cardForm.company_name
					}
				}).then(res => {
					this.loading = false
					if (res.code == 200) {
						if (res.data) {
							this.joinForm.company_name = this.cardForm.company_name
							this.status = 3
						} else {
							this.ruleForm.company_name = this.cardForm.company_name
							this.status = 2
						}
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			// 创建名片
			foundCard() {
				this.$refs['cardForm'].validate((valid) => {
					if (valid) {
						let data = {
							en_job: this.cardForm.en_job,
							en_avatar: this.cardForm.en_avatar,
							en_user_name: this.cardForm.en_user_name,
						}
						if(this.type==1){
							data.company_name=this.cardForm.company_name
						}
						this.loading = true
						this.$axios.post('/api/client/User/edit', data).then(res => {
							this.loading = false
							if (res.code == 200) {
								if(this.type==2){
									this.$eltips(res.msg, 'success')
								}else{
									this.findCompany()
								}
							} else {
								this.$eltips(res.msg, 'error')
							}
						})
					} else {
						console.log('error')
						return;
					}
				});
			},
			// 创建公司
			submit() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						let data = {},url=''
						
						if(this.type==1){
							data={
								company_name: this.ruleForm.company_name,
								simple_name: this.ruleForm.simple_name,
								company_code: this.ruleForm.company_code,
								person_count: this.ruleForm.person_count,
								business_license: this.ruleForm.business_license,
								company_address: this.ruleForm.company_address.join('-'),
								address_detail: this.ruleForm.address_detail,
								logo: this.ruleForm.logo,
							}
							url='/api/client/ES/EnterpriseCertification'
						}
						
						if(this.type==2){
							data=this.ruleForm
							data.images=data.images.join()
							data.company_address=data.company_address.join('-')
							delete data.company_name
							url='/api/client/ES/editCompany'
						}
						
						this.loading = true
						this.$axios.post(url, data).then(res => {
							this.loading = false
							if (res.code == 200) {
								if(this.type==1){
									this.$alert('请耐心等待', '资料审核中', {
										confirmButtonText: '确定',
										callback: action => {
											this.$router.push({
												name: 'Home'
											})
										}
									});
								}else{
									this.$eltips('修改成功')
									this.$router.go(-1)
								}
							} else {
								this.$eltips(res.msg, 'error')
							}
						})
					} else {
						console.log('error')
						return;
					}
				});
			},
			//加入公司
			joinCompany() {
				this.$refs['joinForm'].validate((valid) => {
					if (valid) {
						let data = {
							company_name: this.joinForm.company_name,
							remarks:this.joinForm.remarks
						}
						this.loading = true
						this.$axios.post('/api/client/ES/JoiningEnterprise', data).then(res => {
							this.loading = false
							if (res.code == 200) {
								this.$alert('请耐心等待', '资料审核中', {
									confirmButtonText: '确定',
									callback: action => {
										this.$router.push({
											name: 'Home'
										})
									}
								});
							} else {
								this.$eltips(res.msg, 'error')
							}
						})
					} else {
						console.log('error')
						return;
					}
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.setBusiness {
		position: relative;
		padding: 24px 0;
		min-height: 801px;
		box-sizing: border-box;
		.setBusinessCon {
			width: 1200px;
			margin: 0 auto;
			position: relative;
			z-index: 2;

			.sortCon {
				width: 38px;
				height: 38px;
				border-radius: 50%;
				background-color: rgba(81, 161, 144, 0.5);
				display: flex;
				align-items: center;
				justify-content: center;
				margin-right: 10px;

				.sort {
					width: 30px;
					height: 30px;
					border-radius: 50%;
					font-size: 14px;
					background-color: #51A190;
					color: #fff;
					text-align: center;
					line-height: 34px;
				}
			}

			.fill {
				padding: 33px 43px 38px;
				background-color: #fff;
				border-radius: 16px;
				min-height: calc(100vh - 56px - 48px - 80px);

				.title {
					display: flex;
					align-items: center;
					color: #151515;
					font-size: 22px;
					font-weight: bold;
					margin-bottom: 35px;

					.icon {
						width: 39px;
						height: 39px;
						margin-right: 13px;
					}
				}

				.form {
					width: 800px;

					// padding-left: 52px;
					.el-form-item {
						margin-right: 48px;
					}

					.label,
					.tags {
						display: flex;
						align-items: center;
						flex-wrap: wrap;
						width: 343px;

						.tagsLi {
							margin-right: 10px;
							margin-bottom: 10px;
						}
					}

					.label {
						justify-content: space-between;
						margin-bottom: 20px;
					}
				}

				.buttonG {
					display: flex;
					align-items: center;
					justify-content: flex-end;

					.el-button {
						font-size: 16px;
						border-radius: 16px;
						height: 56px;
						width: 120px;
					}

					.save {
						width: 190px;
					}
				}
			}
		}
	}
</style>

<style lang="scss">
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		box-sizing: border-box;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 400px;
		height: 200px;
		line-height: 200px !important;
		text-align: center;
	}

	.avatar {
		width: 400px;
		height: 200px;
		display: block;
	}

	.album {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		.albums{
			display: flex;
			align-items: center;
		}
		.albumCon{
			position: relative;
			width: 205px;
			height: 127px;
			margin-right: 20px;
			margin-bottom: 20px;
			.close{
				width: 24px;
				height: 24px;
				font-size: 24px;
				position: absolute;
				right: -12px;
				top: -12px;
				z-index: 2;
				cursor: pointer;
			}
		}
		
		.albumLi {
			width: 205px;
			height: 127px;
			margin-right: 16px;
		}
	}

	.photo {
		width: 205px;
		height: 127px;
		line-height: 127px !important;
	}

	.comlogo {
		width: 200px !important;
		height: 200px !important;
		line-height: 200px !important;

		.el-upload--text {
			height: 200px !important;
			line-height: 200px !important;
		}
	}
</style>